$(document).ready(function(){
  $('.previous-editions-carousel').owlCarousel({
    loop:true,
    responsiveClass:true,
    dots: false,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      700: {
        items: 2,
        nav:true,
        loop:false
      },
      1200:{
        items: 4,
        nav:true,
        loop:false
      },
      1600:{
        items:4,
        nav:true,
        loop:false
      }
    }
  });
});
